import styles from './hotline.module.css'
import '../../styles/global.css'

function Hotline() {
  return (
    <div className={styles.hotline_banner}>
      <div className={styles.hotline_left}>
        <h3>HOTLINE MIỄN PHÍ</h3>
      </div>
      <div className={styles.hotline_right}>
        <h3>0984.498.256 - 02103.993.995</h3>
      </div>
    </div>
  );
}

export default Hotline;